import { FolderZipOutlineIcon } from './FolderZipOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 55AE86E1-C6DB-4F41-BC21-1750DB608D23
 * name folder-zip-outline
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-zip-outline.svg
 * tags
 * - Files / Folders 
 */
export const CompressedFolderOutlineIcon = FolderZipOutlineIcon;
export default CompressedFolderOutlineIcon